import React from 'react'
import moment from 'moment'
import Helmet from 'react-helmet'
import ReadNext from '../components/ReadNext'
import { config } from 'config'
import openGraphImage from '../assets/img/open-graph.png'

class MarkdownWrapper extends React.Component {
  maybeRenderPostImage() {
    const { route } = this.props
    const post = route.page.data;
    return post.image ?
      <img
        className="post-image"
        src={require(`../assets/img/posts/${post.image}`)}
        width={post.width ? post.width : "auto"}/>
    : null
  }

  openWindow(channel) {
    const { route } = this.props
    const post = route.page.data
    const url = process.env.NODE_ENV === 'production' ? config.domain : "http://0.0.0.0:8000";
    const h = screen.height;
    const w = screen.width;
    const ww = 700;
    const hh = 500;
    let shareUrl = "";
    switch (channel) {
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${post.title}&url=${encodeURIComponent(url+route.path)}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&title=${post.title}&url=${encodeURIComponent(url+route.path)}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url+route.path)}`;
        break;
      case "buffer":
        shareUrl = `https://buffer.com/add?text=${post.title}&url=${encodeURIComponent(url+route.path)}`;
        break;
      default:
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url+route.path)}`;
    }
    window.open(shareUrl, "", `width=${ww},height=${hh},left=${w/2-ww/2},top=${h/2-hh/2}`);
  }

  render () {
    const { route } = this.props
    const post = route.page.data
    const url = process.env.NODE_ENV === 'production' ? config.domain : "http://0.0.0.0:8000";

    return (
      <div className="page markdown parallax-group">
        <Helmet
            title={`${post.title} | ${config.title}`}
            meta={[
                {"name": "description", "content": post.description},
                {"property": "og:type", "content": "article"},
                {"property": "og:locale", "content": "en_US"},
                {"property": "og:title", "content": post.title},
                {"property": "og:description", "content": post.description},
                {"property": "og:url", "content": url + route.path},
                {"property": "og:site_name", "content": config.title},
                {"property": "og:image", "content": url + "/" + openGraphImage},
                {"property": "og:image:width", "content": post.imageWidth},
                {"property": "og:image:height", "content": post.imageHeight},
                {"property": "twitter:card", "content": "summary"},
                {"property": "twitter:creator", "content": "@scrimmageqa"},
                {"property": "twitter:site", "content": "@scrimmageqa"},
              ]}/>
        <div className="markdown">
          <div className="container">
            {this.maybeRenderPostImage()}
            <h1>{post.title}</h1>
            <div className="post-info">
              {
                post.author &&
                <div className="post-author">
                  <img src={require(`../assets/img/authors/${post.author.split(" ")[0].toLowerCase()}.jpg`)}/>
                  <span>Posted by: {post.author}</span>
                </div>
              }
              <span className="post-date">{moment(post.date).format('MMMM D, YYYY')}</span>
              <div className="social-media">
                <a onClick={() => this.openWindow("twitter")} className="icon-twitter"></a>
                <a onClick={() => this.openWindow("facebook")} className="icon-facebook"></a><br/>
                <a onClick={() => this.openWindow("linkedin")} className="icon-linkedin"></a>
                <a onClick={() => this.openWindow("buffer")} className="icon-buffer"></a>
              </div>
            </div>
            <div className="post-content" dangerouslySetInnerHTML={{ __html: post.body }} />
            <ReadNext post={post} pages={route.pages} />
          </div>
        </div>
      </div>
    )
  }
}

MarkdownWrapper.propTypes = {
  route: React.PropTypes.object,
}

export default MarkdownWrapper



// WEBPACK FOOTER //
// ../wrappers/md.js